var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex p-3 align-items-center"},[_c('img',{staticClass:"cookie",attrs:{"src":"/vuejs-notify/pictures/cookie.svg","alt":""}}),_c('small',{staticClass:"px-3"},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }